import { useAuthStore, useCommonStore } from '@/store';
import { debounce } from 'lodash';

export default async function ({ route, redirect }) {
  const commonStore = useCommonStore();
  const authStore = useAuthStore();

  /** 임시 - 랜딩페이지에서 api호출 안하도록 */
  if (route.name === 'index') {
    commonStore.isHome = true;
    commonStore.isAuth = false;
    commonStore.isError = false;
    return;
  }

  /** 가로사이즈 인식하여 모바일에서 snb닫히도록 */
  let originWidth = 0;

  const handleResize = debounce(() => {
    if (originWidth === window.innerWidth) {
      return;
    }
    if (window.innerWidth < 1280) {
      commonStore.openSide = false;
    } else {
      commonStore.openSide = true;
    }
    originWidth = window.innerWidth;
  }, 1000);

  window.addEventListener('resize', handleResize);

  if (window.innerWidth < 1280) {
    commonStore.openSide = false;
  }

  /** 스크롤 상단으로 가도록 */
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  // TODO : 결제 임시 숨김처리. 추후에 다시 추가 예정.
  // let myInfo
  try {
    // TODO : 결제 임시 숨김처리. 추후에 다시 추가 예정.
    // myInfo = await commonStore.getProfile();
    if (route.name && route.name.includes('auth')) {
      if (commonStore.sessionInfo && route.path !== '/dashboard') {
        redirect('/dashboard');
      }
      return;
    }
    if (!commonStore.sessionInfo) {
      await commonStore.getSessions();
    }
  } finally {
    if (commonStore.sessionInfo && !commonStore.logoLoaded && commonStore.sessionInfo?.role !== 'SUPER_ADMIN') {
      await commonStore.getAcademies();
      commonStore.logoLoaded = true;
    }
    commonStore.selectedMenu = route.matched[0]?.path.split('/:')[0].replace('/', '').replaceAll('/', '-');

    switch (route.name) {
      case 'index': {
        commonStore.isHome = true;
        commonStore.isAuth = false;
        commonStore.isError = false;
        break;
      }
      case 'auth-login': {
        commonStore.isHome = false;
        commonStore.isAuth = true;
        commonStore.isError = false;
        if (commonStore.sessionInfo && route.path !== '/dashboard') {
          redirect('/dashboard');
        }
        break;
      }
      case 'error': {
        commonStore.isAuth = false;
        commonStore.isHome = false;
        commonStore.isError = true;
        break;
      }
      default: {
        if (route.name && route.name?.indexOf('auth') !== -1) {
          commonStore.isHome = false;
          commonStore.isAuth = true;
          commonStore.isError = false;
          break;
        } else {
          commonStore.isAuth = false;
          commonStore.isHome = false;
          commonStore.isError = false;
        }
        if (!commonStore.sessionInfo) {
          // 로그인하면 이동요청한 URL로 리다이렉트 되도록
          if (route.fullPath) {
            // redirect(`/auth/login?from=${route.fullPath}`);
          } else {
            if (route.path.indexOf('auth') !== -1) {
              break;
            }
            // redirect(`/auth/login`);
          }
          authStore.handleLogoutCamStudy()
        } else {
          // TODO : 결제 임시 숨김처리. 추후에 다시 추가 예정.
          // /** 구독정보 미입력시 리다이렉트되도록 */
          // if (session.role ==='OWNER' && !myInfo.subscriptionAcceptedAt) {
          //   redirect('/auth/signup?agreeSubscription=false');
          // }
        }
      }
    }
  }
}
